import React from 'react';
import {theme} from '../../App.jsx';
import TextField from '@mui/material/TextField';
import { variant, margin } from '../../constants/form';

export default function Input({ name, label, type = 'text', placeholder = '', formData, errors, formValidations, handleFieldChange, handleFieldBlur = () => {} }) {

    return (
        <TextField
            InputProps={{ sx: { borderRadius: 4, background: "white" } }}
            // size="small"
            type={type}
            variant={variant}
            margin={margin}
            fullWidth
            label={label}
            name={name}
            value={formData[name]}
            placeholder={placeholder}
            onChange={handleFieldChange}
            onBlur={handleFieldBlur}
            error={!!errors[name]}
            helperText={errors[name]}
            required={formValidations[name]?.required}
            sx={{
                '& .MuiOutlinedInput-notchedOutline':{
                        borderColor: theme.palette.primary.main
                    },
            }}
        />
    )
}
